import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  ref: "el",
  class: "d-lg-flex my-3"
}
const _hoisted_2 = { class: "mx-5 align-self-start" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", null, "プリセット３Dモデル", -1)
const _hoisted_4 = {
  id: "v-model-select-dynamic",
  class: "demo"
}
const _hoisted_5 = ["value"]
const _hoisted_6 = { class: "mx-5 align-items-start flex-grow-1" }
const _hoisted_7 = { class: "d-lg-flex input-group my-5" }
const _hoisted_8 = { class: "d-lg-flex" }
const _hoisted_9 = {
  id: "a-frameWindow",
  ref: "termOfUseRef",
  class: "a-frameWindow term-of-use",
  src: "./public/iframe_html/aFrame.html",
  frameborder: "0",
  width: "300",
  height: "540"
}
const _hoisted_10 = {
  id: "v-model-select",
  class: "mx-3 flex-grow-1"
}
const _hoisted_11 = ["value"]

import { onMounted, ref } from "vue";
import axios from "axios";
import { translation } from "../../lang/Translation";

export default /*#__PURE__*/_defineComponent({
  __name: '3DmodelUpload',
  setup(__props) {

const t = translation;
// 変数
const fileInfo = ref([]);
const environmentList = ref([]);
const fileTilte = ref(t.to("タイトル", "save_dialog_title_input_label"));
let files;

onMounted(() => {
  getPresetList();
  getEnvironment();
});

// モデルリスト取得
async function getPresetList() {
  await axios.get("./webapi/file/get_preset_list").then((e) => {
    fileInfo.value = JSON.parse(e.data);
  });
}

// A-frame背景リスト取得
async function getEnvironment() {
  const response = await axios.get("./public/preset/environment.json");
  environmentList.value = JSON.parse(JSON.stringify(response.data));
  // console.log(environmentList);
}

// 背景変更関数
function changeEnvironment() {
  const iframe = (document.getElementById("a-frameWindow") as HTMLIFrameElement)
    .contentWindow;
  const environment: HTMLInputElement = document.getElementById(
    "environment"
  ) as HTMLInputElement;
  iframe.postMessage(["environment", environment.value], "*");
}

// 選択した3Dモデル表示
async function selectModelView(e: any) {
  // console.log(e.target.value);
  const iframe = (document.getElementById("a-frameWindow") as HTMLIFrameElement)
    .contentWindow;
  const modelName = e.target.value;
  const modelURL = "../preset/" + modelName + "/model.glb";
  iframe.postMessage(["model", modelURL], "*");
  fileTilte.value = modelName;
}

// inputしたファイル情報を変数に保持
function fileChanged(e: any) {
  const extension = e.target.files[0].name.split(".").pop();
  try {
    if (extension === "glb") {
      files = e.target.files;
      // console.log(files[0].name);
    } else {
      throw "３Dモデルではないファイルが選択されました\n３Dモデルファイルを選択してください";
    }
  } catch (error) {
    alert(error);
    console.error(error);
    e.target.value = null;
  }
}

//モデルファイルアップロード
async function uploadModelFile(uploadFile, config) {
  const modelData = new FormData();
  const extension = uploadFile.name.split(".").pop();

  if (extension === "glb") {
    modelData.append("userfile", uploadFile);
    const modelResponse = await axios.post(
      "./webapi/file/preset_file_upload_api",
      modelData,
      config
    );
    // console.log(modelResponse);
  } else {
    return Promise.reject("ファイルをアップロードできません\n やり直してください");
  }
  getPresetList();
}

// iframeモデル表示
async function modelView(fileName) {
  const iframe = (document.getElementById("a-frameWindow") as HTMLIFrameElement)
    .contentWindow;
  if (fileName.lastIndexOf(".") != -1)
    fileName = fileName.substring(0, fileName.lastIndexOf("."));
  const modelURL = "../preset/" + fileName + "/model.glb";
  await iframe.postMessage(["model", modelURL], "*");
  fileTilte.value = fileName;
}

// サムネイルデータ取得
function getThumbnail() {
  try {
    const frame: HTMLIFrameElement = document.querySelector(".a-frameWindow");
    const scene = frame.contentDocument.querySelector("a-scene") as any;
    const canvas = (scene.components.screenshot as any).getCanvas().toDataURL();
    const bin = atob(canvas.split(",")[1]);
    const buffer: any = new Uint8Array(bin.length);
    for (let i = 0; i < bin.length; i++) {
      buffer[i] = bin.charCodeAt(i);
    }
    const blob: Blob = new Blob([buffer.buffer], { type: "image/png" });
    // console.log(blob);
    return blob;
  } catch (error) {
    console.error("画像が保存できませんでした。");
  }
}

// サムネイルアップロード処理
async function uploadThumbnaiFile(fileName, config) {
  const thumbnailData = new FormData();
  const thumbnail = getThumbnail();
  thumbnailData.append("userfile", thumbnail, fileName);
  const thumbnailRes = await axios.post(
    "./webapi/file/thumbnail_upload_api",
    thumbnailData,
    config
  );
  // console.log(thumbnailRes);
}

// モデルファイルアップロード関連処理
async function fileUploadProcess(e: any) {
  e.preventDefault();
  const uploadFile = files[0];
  const fileName = new String(uploadFile.name).substring(
    uploadFile.name.lastIndexOf("/") + 1
  );
  const config = {
    headers: {
      "content-type": "multipart/form-data",
    },
  };

  // モデルアップロード処理
  uploadModelFile(uploadFile, config)
    .then(() => {
      // アップロードモデル表示
      modelView(fileName);
    })
    .catch((e) => {
      alert(e);
      console.error(e);
    });
}

// サムネイル撮影処理
async function ThumbnaiFileUploadProcess(e: any) {
  // console.log(fileTilte.value);
  e.preventDefault();
  const frame: HTMLIFrameElement = document.querySelector(".a-frameWindow");
  const scene = frame.contentDocument.querySelector("a-scene") as any;
  const canvas = (scene.components.screenshot as any).getCanvas();

  // console.log(canvas);
  if (fileTilte.value !== "タイトル") {
    const fileName = fileTilte.value;
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    // サムネイル撮影、アップロード処理
    uploadThumbnaiFile(fileName, config);
    alert("サムネイルを撮影しました");
  } else {
    alert("モデルがアップロードされていません\nアップロードしてください");
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("select", {
          class: "form-select h-100",
          multiple: "",
          size: "30",
          onChange: selectModelView
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fileInfo.value, (info) => {
            return (_openBlock(), _createElementBlock("option", {
              key: info,
              value: info
            }, _toDisplayString(info), 9, _hoisted_5))
          }), 128))
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("input", {
          id: "input3DmodelFile",
          type: "file",
          class: "form-control",
          "aria-describedby": "input3DmodelFile",
          "aria-label": "Upload",
          accept: ".glb",
          onChange: fileChanged
        }, null, 32),
        _createElementVNode("button", {
          id: "inputGroupFileAddon04",
          class: "btn btn-outline-secondary",
          type: "submit",
          onClick: fileUploadProcess
        }, " 送信 ")
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("iframe", _hoisted_9, null, 512),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("h1", null, _toDisplayString(fileTilte.value), 1),
          _createElementVNode("select", {
            id: "environment",
            class: "form-select my-5",
            onChange: changeEnvironment
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(environmentList.value, (environment) => {
              return (_openBlock(), _createElementBlock("option", {
                key: environment.id,
                value: environment.value
              }, _toDisplayString(environment.name), 9, _hoisted_11))
            }), 128))
          ], 32),
          _createElementVNode("div", { class: "h-75 d-flex flex-row-reverse flex-column gap-2" }, [
            _createElementVNode("button", {
              id: "inputGroupFileAddon04",
              class: "btn btn-outline-secondary mt-auto",
              type: "button",
              onClick: ThumbnaiFileUploadProcess
            }, " サムネイル撮影 ")
          ])
        ])
      ])
    ])
  ], 512))
}
}

})